// extracted by mini-css-extract-plugin
module.exports = {"container":"FormSection_container__3Hdc5","rhombus":"FormSection_rhombus__2L13Q","content":"FormSection_content__1dd67","bg-image":"FormSection_bg-image__2maCN"};